const blendlist = [
  [
    {
      id: 0,
      title: "Plymouth Baracuda",
      img: "https://cdna.artstation.com/p/assets/images/images/040/003/826/large/ritvik-gupta-final.jpg?1627567268",
      src: "https://www.artstation.com/artwork/oANZG4",
    },
    {
      id: 1,
      title: "Chess Board",
      src: "https://www.artstation.com/artwork/d8gn6J",
      img: "https://cdna.artstation.com/p/assets/images/images/031/035/542/large/ritvik-gupta-chess.jpg?1602409473",
    },
    {
      id: 2,
      title: "Hallway from 'joker' ",
      img: "https://cdna.artstation.com/p/assets/images/images/038/082/022/large/ritvik-gupta-4.jpg?1622120837",
      src: "https://www.artstation.com/artwork/484JAW",
    },
  ],
  [
    {
      id: 3,
      title: "Luxary Bathroom",
      img: "https://cdna.artstation.com/p/assets/images/images/031/045/118/small/ritvik-gupta-2.jpg?1602434759",
      src: "https://www.artstation.com/artwork/68kq0V",
    },
    {
      id: 4,
      title: "Lobby",
      img: "https://cdna.artstation.com/p/assets/images/images/037/709/576/small/ritvik-gupta-2.jpg?1621103840",
      src: "https://www.artstation.com/artwork/18P0Je",
    },
    {
      id: 5,
      title: "Living Room",
      img: "https://i.imgur.com/riFmE2A.png",
      src: "https://www.artstation.com/artwork/eaVnA3",
    },
  ],
  [
    {
      id: 6,
      title: "Newyork subway",
      img: "https://cdna.artstation.com/p/assets/images/images/031/075/808/large/ritvik-gupta-v-png0001.jpg?1602530883",
      src: "https://www.artstation.com/artwork/oAZEk4",
    },
    {
      id: 7,
      title: "Traditional Bathroom",
      img: "https://cdnb.artstation.com/p/assets/images/images/031/603/541/large/ritvik-gupta-2.jpg?1604080163",
      src: "https://www.artstation.com/artwork/Aq2X0W",
    },
    {
      id: 8,
      title: "Modular Kitchen",
      img: "https://cdna.artstation.com/p/assets/images/images/031/327/264/large/ritvik-gupta-2.jpg?1603293246",
      src: "https://www.artstation.com/artwork/XnbVkD",
    },
  ],
];

export default blendlist;
